module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACLSURBVGiB7c/LDYNQDETReR1kkS4okQLSK4rSwrDBiEUU8bGUZ3TP3tZcCQAAAAAAAGW0K8e2H5JGSc+cOau3pFdr7ZP8dz/bg+3JeSbbw9+CthLj+okKCXH9RYULcf1GhRNx/UeFA3F1osKOuHpR4Udc3ajwJa5+VNjE3ScqLHH3igIAAAAAAECOGQLCADTdo1bOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xl1.png
// module id = /PMt
// module chunks = 1